import React from "react";
import LoadingGif from '../assets/img/yoma_animation.gif'
import '../assets/css/loader.css'
import { Dimmer } from 'semantic-ui-react';

const Loader = () => {
    return (
        <Dimmer active>
            <img src={LoadingGif} alt="loading"/>
        </Dimmer>
    );
}

export default Loader;
